'use client'
import{jsx as d}from"react/jsx-runtime";var o=()=>d("div",{children:"AdminLayout"});export{o as a};
